import { buildCloudinaryImageUrl } from './cloudinary';

const SERVICE_PHASE_IMAGES = {
  prediction: {
    version: 'v1779299111',
    publicId: 'case-study-phase-prediction_c50xrw',
    format: 'jpg',
  },
  execution: {
    version: 'v1779299111',
    publicId: 'case-study-phase-execution_b6essg',
    format: 'jpg',
  },
};

/** Strategy / discovery phase imagery (services listing + detail pages). */
export const CASE_STUDY_PREDICTION_IMAGE = buildCloudinaryImageUrl(
  SERVICE_PHASE_IMAGES.prediction,
  'service'
);

/** Implementation / execution phase imagery (services listing + detail pages). */
export const CASE_STUDY_EXECUTION_IMAGE = buildCloudinaryImageUrl(
  SERVICE_PHASE_IMAGES.execution,
  'service'
);

const SERVICE_SVG_ILLUSTRATIONS = {
  caseStudy: {
    version: 'v1779299558',
    publicId: 'case-study_bwzppv',
    format: 'svg',
  },
  phase1Prediction: {
    version: 'v1779299558',
    publicId: 'phase1-prediction_kc8lys',
    format: 'svg',
  },
  phase2Prediction: {
    version: 'v1779299564',
    publicId: 'phase2-prediction_xveafs',
    format: 'svg',
  },
};

/** Replaces `public/media/case-study.svg`. */
export const CASE_STUDY_SVG = buildCloudinaryImageUrl(
  SERVICE_SVG_ILLUSTRATIONS.caseStudy,
  'illustration'
);

/** Replaces `public/media/phase1-prediction.svg`. */
export const PHASE1_PREDICTION_SVG = buildCloudinaryImageUrl(
  SERVICE_SVG_ILLUSTRATIONS.phase1Prediction,
  'illustration'
);

/** Replaces `public/media/phase2-prediction.svg`. */
export const PHASE2_PREDICTION_SVG = buildCloudinaryImageUrl(
  SERVICE_SVG_ILLUSTRATIONS.phase2Prediction,
  'illustration'
);
